// Debug utility to help troubleshoot API issues

export const debugAPI = {
  // Test fetch-ind-info
  async testIndicationInfo(indicationCode: string, nccnType: string = 'nccn') {
    try {
      const response = await fetch(`/fetch-ind-info?indication_code=${indicationCode}&nccn_type=${nccnType}`);
      const data = await response.json();
      console.log('Indication Info Response:', data);
      return data;
    } catch (error) {
      console.error('Indication Info Error:', error);
      throw error;
    }
  },

  // Test fetch-trials
  async testFetchTrials(indicationCode: string, nccnType: string = 'nccn', nccnVersion: string = '2.2025') {
    try {
      const url = `/fetch-trials?indication_code=${indicationCode}&nccn_type=${nccnType}&nccn_version=${nccnVersion}`;
      console.log('Fetching trials from:', url);
      const response = await fetch(url);
      const data = await response.json();
      console.log('Trials Response:', {
        isArray: Array.isArray(data),
        length: Array.isArray(data) ? data.length : 'N/A',
        data: data,
      });
      return data;
    } catch (error) {
      console.error('Trials Error:', error);
      throw error;
    }
  },

  // Test with different parameters
  async testAllVariations(indicationCode: string) {
    const variations = [
      { nccn_type: 'nccn', nccn_version: '2.2025' },
      { nccn_type: 'nccn', nccn_version: '2.2024' },
      { nccn_type: 'non-nccn', nccn_version: '2.2025' },
      { nccn_type: 'non-nccn', nccn_version: '2.2024' },
    ];

    for (const variant of variations) {
      console.log(`\n=== Testing: nccn_type=${variant.nccn_type}, nccn_version=${variant.nccn_version} ===`);
      await this.testFetchTrials(indicationCode, variant.nccn_type, variant.nccn_version);
    }
  },
};

// Make it available globally for browser console
if (typeof window !== 'undefined') {
  (window as any).debugAPI = debugAPI;
}
